import { Box } from '@atlaskit/primitives';
import { ExternalLink } from '@atlassian/mpac-ui';
import { AccordionError } from '../AccordionError/AccordionError';
import { AccordionLoading } from '../AccordionLoading/AccordionLoading';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DATA_RESIDENCY_DOC_LINK = 'https://support.atlassian.com/security-and-access-policies/docs/understand-data-residency/';
export const DataResidency = _ref => {
  let {
    isLoading,
    hasError,
    enableAppificationChanges
  } = _ref;
  if (isLoading) {
    return /*#__PURE__*/_jsx(AccordionLoading, {
      testId: "data-residency-loader"
    });
  }
  if (hasError) {
    /* if we fail to get roa status */
    return /*#__PURE__*/_jsx(AccordionError, {
      label: "Data residency error"
    });
  }
  const productText = enableAppificationChanges ? 'apps' : 'products';
  const marketplaceAppText = enableAppificationChanges ? 'Marketplace app' : 'app';
  return /*#__PURE__*/_jsxs(Box, {
    children: ["This ", marketplaceAppText, " stores End-User Data exclusively within Atlassian ", productText, " and services that support data residency options, as outlined", ' ', /*#__PURE__*/_jsx(ExternalLink, {
      href: DATA_RESIDENCY_DOC_LINK,
      children: "here"
    }), "."]
  });
};